module.exports = __webpack_public_path__ + "media/images/lane/blacn-icon-twitter-bb3ba8081f0936af6c7f58099ee4da57.svg";